import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { AccountService } from '@services/account.service';
import { EnvironmentService } from '@services/environment/environment.service';
import { SessionVaultService } from '@services/session-vault/session-vault.service';
import { SessionController } from 'src/app/auth/session/session-controller';
import { LoadingModalService } from 'src/app/shared/components/common/loading-modal/loading-modal.service';

@Component({
  selector: 'app-unlock',
  templateUrl: './unlock.page.html',
  styleUrls: ['./unlock.page.scss'],
  standalone: false,
})
export class UnlockPage implements OnInit {
  @ViewChild('logo') logoElement: ElementRef;
  public userEmail: string;

  constructor(
    public accountService: AccountService,
    private readonly _session: SessionController,
    private sessionVaultService: SessionVaultService,
    private _environmentService: EnvironmentService,
    private _loadingModalService: LoadingModalService
  ) {}

  async ngOnInit(): Promise<void> {
    this.userEmail = await this.accountService.getUserEmail();
  }

  ionViewDidEnter(): void {
    this.logoElement.nativeElement.src = this._environmentService.isMdrBranch()
      ? 'assets/imgs/alberta-mdr.svg'
      : 'assets/imgs/alberta-default.svg';
  }

  async unlockClicked() {
    try {
      if (await this.sessionVaultService.canUnlock()) {
        const result = await this.sessionVaultService.getSessionFromVault();
      } else if (await this.sessionVaultService.isUnlocked) {
        await this.sessionVaultService.refreshUnlockStatus();
      } else {
        //Something went very wrong. This should never happen. User is on lock screen but vault is in undefined state
        window.logger.captureErrorWithExtras('Critical Error: Vault cannot be unlocked');
        await this.logoutClicked();
      }
    } catch (err) {
      window.logger.captureErrorWithExtras('Critical Error during Unlock', err);
    }
  }

  async logoutClicked() {
    await this._loadingModalService.present({
      message: '',
      showCancelButton: false,
    });
    // clears the vault and restarts the app
    await this._session.logout({ reason: 'lock screen' });
  }
}
